<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="toc"></a><a id="page_vii"><strong>CONTENTS</strong></a></h3><a id="page_vii">
</a><p class="tocfront"><a id="page_vii"></a><a class="nounder" href="#/xhtml/foreword#for">Foreword by Marshall Goldsmith</a></p>
<p class="tocfront"><a class="nounder" href="#/xhtml/preface#preface">Preface</a></p>
<p class="tocpart"><a class="nounder" href="#/xhtml/part01#part01"><strong><span class="small">PART I</span></strong> <em>Value of the Female Vision</em></a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01"><strong>1</strong> What Women See</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><strong>2</strong> Why What Women See Matters</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>3</strong> Early Warning Signals</span></p>
<p class="tocpart"><span class="nounder" href="#/xhtml/part02#part02" title="Link target outside of Sample"><strong><span class="small">PART II</span></strong> <em>Elements of the Female Vision</em></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong>4</strong> Broad-Spectrum Notice</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><strong>5</strong> Satisfaction Day by Day</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><strong>6</strong> The Social Fabric</span></p>
<p class="tocpart"><span class="nounder" href="#/xhtml/part03#part03" title="Link target outside of Sample"><strong>PART III</strong> <em>Profiting from the Female Vision</em></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><strong>7</strong> Acting on Your Vision</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample"><strong>8</strong> Creating the Conditions</span></p>
<p class="tocback1"><span class="nounder" href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4ddec420